import { ISOString } from '../common';

export interface IDocument {
  id: string;
  fileName: string;
  documentType: DocumentType;
  date: ISOString;
}

export enum DocumentType {
  TRANSCRIPT = 'transcript',
  FINANCIAL_AID_AWARD_LETTER = 'financialAidAwardLetter',
  EMPLOYMENT_AUTHORIZATION_DOCUMENT = 'employmentAuthorizationDocument',
  STUDENT_AID_REPORT = 'studentAidReport',
  THANK_YOU_LETTER_VIDEO = 'thankYouLetterVideo',
  ENROLLMENT_VERIFICATION = 'enrollmentVerification',
  PUBLIC_EVENT_IMAGE = 'publicEventImage',
  IMAGE = 'image',
  HEADSHOT = 'headshot',
  RESUME = 'resume',
  SAT = 'sat',
  ACT = 'act',
  IB_EXAM = 'ibExam',
  AP_EXAM = 'apExam',
  GENERIC = 'generic',
}

/**
 * Pre-submit AI document review status. Mirrors the backend `DocumentReviewStatus`
 * (prosper-services src/types/document.ts) returned by the /documents/{id}/review endpoint.
 * PENDING while queued/processing; PASSED when acceptable; NEEDS_CORRECTION while attempts
 * remain (student re-uploads); NEEDS_REVIEW when the attempt limit is hit (admin reviews).
 */
export enum DocumentReviewStatus {
  PENDING = 'pending',
  PASSED = 'passed',
  NEEDS_CORRECTION = 'needsCorrection',
  NEEDS_REVIEW = 'needsReview',
}

/**
 * Response from the /documents/{id}/review endpoint (POST enqueue + GET poll).
 * `attempts`/`attemptLimit` are backend-owned; `summary`/`issues`/`requiredActions` carry the
 * AI feedback once a verdict exists.
 */
export interface IDocumentReviewResponse {
  status: DocumentReviewStatus;
  attempts: number;
  attemptLimit: number;
  comments?: string | null;
  isLowConfidence?: boolean | null;
  summary?: string;
  issues?: string[];
  requiredActions?: string[];
}

export enum DocumentParamsType {
  UNIVERSITIES = 'universities',
  INSTITUTIONS = 'institutions',
}

export enum DocumentRequestType {
  ISIR = 'ISIR',
  CLEARINGHOUSE = 'ClearingHouse',
}
